function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "path-1",
  x: 0,
  y: 0,
  width: 28,
  height: 2.94737,
  rx: 0.3
}), /*#__PURE__*/React.createElement("rect", {
  id: "path-3",
  x: 0.84229,
  y: 0.76172,
  width: 10.5795,
  height: 2.59679,
  rx: 0.3
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "ic_product_st_archive"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.5,2.5 L26.5,2.5 L26.5,20 C26.5,20.2761 26.2761,20.5 26,20.5 L2,20.5 C1.72386,20.5 1.5,20.2761 1.5,20 L1.5,2.5 Z",
  id: "Path",
  stroke: "currentColor",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", {
  id: "Clipped"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinejoin: "round",
  mask: "url(#mask-2)",
  x: 0,
  y: 0,
  width: 28,
  height: 2.94737,
  rx: 0.3
})), /*#__PURE__*/React.createElement("g", {
  id: "Clipped",
  transform: "translate(8.000000, 4.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-4",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-3"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinejoin: "round",
  mask: "url(#mask-4)",
  x: 0.84229,
  y: 0.76172,
  width: 10.5795,
  height: 2.59679,
  rx: 0.3
}))));

var SvgIcProductStArchive = function SvgIcProductStArchive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "21px",
    viewBox: "0 0 28 21",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcProductStArchive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_product_st_archive.0cb2aac0.svg";
export { ForwardRef as ReactComponent };